{
  "integrationCallback": {
    "title": "Conectar FieldOps",
    "loading": "Finalizando la conexión con FieldOps…",
    "success": "FieldOps está conectado al espacio de trabajo donde comenzaste.",
    "providerError": "FieldOps no aprobó la conexión. Puedes empezar de nuevo cuando quieras.",
    "invalidAttempt": "Este intento de conexión no existe, ha caducado o ya se ha utilizado. Empieza de nuevo.",
    "forbidden": "Ya no tienes permiso para conectar FieldOps en ese espacio de trabajo.",
    "failed": "No pudimos completar la conexión con FieldOps. Comprueba tu conexión y empieza de nuevo.",
    "busy": "Hay otro cambio de conexión en curso. Espera a que termine y empieza de nuevo.",
    "signedOut": "Inicia sesión en Gripp y luego inicia una nueva conexión con FieldOps desde Configuración.",
    "retryHint": "Vuelve a Configuración, selecciona el espacio de trabajo que quieres conectar e inicia una nueva conexión.",
    "settings": "Volver a Configuración",
    "signIn": "Iniciar sesión",
    "successTitle": "FieldOps conectado",
    "failureTitle": "Conexión no completada"
  },
  "home": {
    "menu": {
      "title": "Inicio"
    },
    "page": {
      "title": "Inicio"
    },
    "search": {
      "placeholder": "Buscar"
    },
    "map": {
      "label": "Mapa de actividad",
      "loading": "Cargando mapa…",
      "error": "No se pudieron cargar los datos del mapa.",
      "empty": "Sin datos para este período.",
      "emptyAssets": "Sin activos para este período.",
      "emptyActivity": "Sin actividad para este período.",
      "emptyRoutines": "Sin actividad de rutinas para este período.",
      "emptyProducts": "Sin productos para este período.",
      "noResults": "Sin resultados para esta búsqueda."
    },
    "activity": {
      "title": "Actividad",
      "total": "{{count}} en total",
      "viewAll": "Ver todo",
      "solved": "Resuelto",
      "pending": "Pendiente",
      "urgent": "Urgente",
      "error": "No se pudieron cargar los datos de actividad",
      "empty": "Sin actividad para este período",
      "plot": "Trazar actividades en el mapa"
    },
    "cards": {
      "viewAll": "Ver todo",
      "error": "No se pudieron cargar los datos"
    },
    "assets": {
      "title": "Activos",
      "empty": "Sin activos para este período",
      "plot": "Trazar activos en el mapa",
      "filterBy": "Filtrar mapa por {{status}}"
    },
    "routines": {
      "title": "Rutinas",
      "empty": "Sin rutinas",
      "plot": "Trazar ubicaciones de rutinas en el mapa",
      "filterBy": "Trazar {{name}} en el mapa"
    },
    "products": {
      "title": "Productos",
      "empty": "Sin productos",
      "plot": "Trazar productos en el mapa",
      "filterBy": "Trazar {{name}} en el mapa"
    },
    "campaigns": {
      "title": "Campañas",
      "empty": "Sin campañas"
    },
    "customers": {
      "title": "Clientes",
      "empty": "Sin clientes",
      "sample": "Datos de muestra",
      "active": "Activo",
      "pending": "Pendiente",
      "new": "Nuevo"
    },
    "plot": {
      "activity": "Mostrando actividades",
      "asset": "Mostrando activos",
      "routine": "Mostrando ubicaciones de rutinas",
      "product": "Mostrando productos"
    },
    "timeRange": {
      "label": "Rango de tiempo",
      "today": {
        "label": "Hoy",
        "a11y": "Hoy"
      },
      "7d": {
        "label": "7D",
        "a11y": "Últimos 7 días"
      },
      "30d": {
        "label": "30D",
        "a11y": "Últimos 30 días"
      },
      "90d": {
        "label": "90D",
        "a11y": "Últimos 90 días"
      },
      "1y": {
        "label": "1Y",
        "a11y": "Último año"
      },
      "all": {
        "label": "Todo",
        "a11y": "Todo el tiempo"
      }
    }
  },
  "accountPage": {
    "header": {
      "accountTypes": "Tipos de cuenta",
      "newUsersSetup": "Los nuevos usuarios se agregarán como"
    },
    "types": {
      "general": "General",
      "admin": "Admin",
      "restricted": "Restringida",
      "anonymous": "Anónima"
    },
    "table": {
      "headers": {
        "accountType": "Tipo de cuenta",
        "accessActivity": "¿Acceso a la actividad?",
        "accessSettings": "¿Acceso a Configuración?"
      },
      "columns": {
        "restrictedToActivitiesNote": "Limitada a activos y grupos compartidos",
        "generalToSettingsNote": "Limitada a activos y personas"
      }
    },
    "info": {
      "header": "Tipos de cuenta explicados",
      "admin": "Ideal para propietarios de lugares de trabajo, altos directivos y administradores de oficina.",
      "general": "Ideal para personal y empleados de tiempo completo. (Nuestro valor predeterminado recomendado.)",
      "restricted": "Ideal para visitantes conocidos, proveedores, trabajadores a tiempo parcial y contratistas que requieren acceso parcial o limitado.",
      "anonymous": "Para personas que no se han registrado con Gripp. Solo pueden enviar informes, notas o rutinas en función de lo que escanean."
    },
    "menu": {
      "accountPage": "Cuenta",
      "settingsPage": "Configuración",
      "workspaceSettingsPage": "Configuración del espacio de trabajo"
    },
    "workplaceTitle": "Gestión y datos del lugar de trabajo",
    "downloadData": "Descargar datos",
    "dataExport": {
      "splitToRows": "Dividir en filas",
      "addAllAssetInfo": "Agregar toda la información del activo",
      "cancel": "Cancelar",
      "title": "Exportar Datos",
      "download": "Descargar"
    }
  },
  "account": {
    "allWorkspaces": "Todos los espacios de trabajo",
    "create": {
      "button": "Agregar usuario",
      "form": {
        "email": "Correo electrónico",
        "firstName": "Nombre",
        "lastName": "Apellido",
        "role": "Rol"
      },
      "validation": {
        "emailRequired": "El correo electrónico es requerido",
        "role": "Se requiere rol",
        "validEmail": "Por favor introduzca una dirección de correo electrónico válida"
      }
    },
    "filter": {
      "apply": "Aplicar",
      "columnSelection": "Columnas",
      "columns": {
        "createdAt": "Agregado",
        "createdDate": "Fecha de ingreso",
        "createdTime": "Hora de ingreso",
        "email": "Correo electrónico",
        "groups": "Grupos",
        "groupNames": "Nombres de Grupos",
        "assets": "Activos",
        "jobTitle": "Título profesional",
        "location": "Ubicación",
        "name": "Nombre (requerido)",
        "phone": "Número de teléfono",
        "roles": "Rol",
        "workspace": "Espacio de trabajo"
      },
      "searchPlaceholder": "Buscar nombre, número o correo electrónico",
      "columnButton": "Columnas",
      "groupsButton": "Grupos",
      "accountTypesButton": "Roles",
      "noAccountTypes": "No hay roles",
      "groups": "Grupos",
      "accountTypes": "Roles",
      "default": "Predeterminado",
      "viewResults": "Ver {{count}} resultados"
    },
    "groups": {
      "addPeopleTo": "Añadir {{count}} personas a:",
      "addPersonTo": "Añadir 1 persona a:"
    },
    "list": {
      "accountType": "Rol",
      "role": "Rol",
      "added": "Agregado",
      "createdDate": "Fecha de ingreso",
      "createdTime": "Hora de ingreso",
      "email": "Correo electrónico",
      "groups": "Grupos",
      "assets": "Activos",
      "activity": "Actividad",
      "jobTitle": "Título profesional",
      "location": "Ubicación",
      "name": "Nombre",
      "phone": "Número de teléfono",
      "workspace": "Espacio de trabajo"
    },
    "topBar": {
      "peopleSelected": "{{count}} personas seleccionadas",
      "personSelected": "1 persona seleccionada"
    },
    "menu": {
      "confirmDelete": {
        "primaryButton": "Sí",
        "secondaryButton": "Cancelar",
        "title": "¿Estás seguro de que quieres eliminar {{accountName}}?"
      }
    },
    "detail": {
      "removeAccount": "Eliminar cuenta",
      "viewActivity": "Ver actividad",
      "activityPanel": {
        "description": "Incluye actividad que esta persona creó, respondió, o a la que se le otorgó acceso."
      }
    }
  },
  "activity": {
    "filter": {
      "cancel": "Cancelar",
      "groups": "Grupos",
      "activityOptions": "Opciones de Actividad",
      "activityTypes": "Tipos de Actividades",
      "options": "Opciones",
      "types": "Tipos",
      "notes": "Notas",
      "note": "Nota",
      "pending": "Pendiente",
      "reset": "Reiniciar",
      "routines": "Rutinas",
      "searchPlaceholder": "Buscar títulos de actividades o nombre del activo",
      "searchLabels": "Buscar etiquetas",
      "solved": "Resuelto",
      "title": "Filtros",
      "labels": "Etiquetas",
      "urgent": "Urgente",
      "date": "Fecha",
      "all": "Todo",
      "day": "día",
      "week": "semana",
      "month": "mes",
      "today": "Hoy",
      "thisMonth": "Últimos 30 días",
      "thisWeek": "Últimos 7 días",
      "custom": "Personalizado",
      "customDate": "Fecha personalizada",
      "from": "De",
      "to": "A",
      "mentions": "Menciones",
      "scheduled": "Programado",
      "default": "Predeterminado",
      "notScheduled": "No programado",
      "pinned": "Fijado",
      "everything": "Todo",
      "onlyMentions": "Solo menciones",
      "onlyPinned": "Solo fijados",
      "onlyScheduled": "Solo programados",
      "sort": "Ordenar",
      "viewResults": "Ver {{count}} resultados",
      "combinedGroups": "Filtración combinada",
      "notGrouped": "(sin grupo)",
      "notLabeled": "(sin etiqueta)"
    },
    "search": {
      "title": "Buscar",
      "search": "Buscar",
      "recentSearches": "Búsquedas recientes"
    },
    "header": {
      "title": "Actividad",
      "view": "Ver",
      "viewAll": "Ver todo"
    },
    "list": {
      "youAreMentioned": "Te han mencionado."
    },
    "menu": {
      "title": "Actividad",
      "titlePlural": "Actividades"
    },
    "calendar": {
      "truncated": "Mostrando {{shown}} de {{total}} actividades. Añade un filtro para verlas todas."
    },
    "textEmpty": "Sin actividad",
    "topBar": {
      "results": "resultados"
    },
    "sort": {
      "mostRecent": "Última actualización",
      "reminderDate": "Fecha de recordatorio",
      "oldest": "Fecha de creación"
    },
    "edit": {
      "tab": {
        "activity": "Actividad",
        "routine": "Rutina"
      }
    },
    "tapScan": "Pulse \"+\" para escanear activos o códigos de invitación.",
    "messageBubble": {
      "joinWorkspace": {
        "title": "¡Únete a un espacio de trabajo!",
        "description": "Aún no estás en un espacio de trabajo.\n¡Escanea un código de invitación para unirte a\nun espacio de trabajo!"
      },
      "addActivity": {
        "title": "Agregar Actividad",
        "description": "Aún no tienes ninguna actividad.\nToca '+' para agregar un reporte o nota sobre tu activo y mantener informado a tu equipo."
      },
      "addAsset": {
        "title": "Agregar Activos",
        "description": "Aún no tienes activos.\nToca '+' para escanear y agregar tu primer activo para comenzar."
      },
      "or": "o",
      "newSub": "iniciar una nueva suscripción",
      "here": "aquí"
    }
  },
  "admin": {
    "menu": {
      "admin": "Gente",
      "workspaces": "Espacios de trabajo"
    }
  },
  "alerts": {
    "addAnother": "Agregar otro",
    "create": {
      "alertName": "Nombre de la alerta",
      "asset(s)": "Activo(s)",
      "assetSearchPlaceholder": "Buscar un nombre de activo",
      "assets": "Activos",
      "doNotAlert": "<0>(Opcional)</0><1>No alertar entre:</1>",
      "groupSearchPlaceholder": "Buscar un nombre de grupo",
      "groups": "Grupos",
      "promptRoutine": "<0>(Opcional)</0><1>Seleccione una rutina</1><0>para avisar con esta alerta:</0>",
      "promptRoutinePlaceholder": "ninguna rutina seleccionada",
      "title": "Crear Alerta",
      "what": "1. Escoge lo que:",
      "when": "3. Escoge cuándo:",
      "why": "2. Escoge por qué:"
    },
    "setAlert": "Agregar alerta",
    "setANewAlert": "Configurar una nueva alerta",
    "createButton": "Crear Nueva",
    "createNewAlert": "Crear una nueva Alerta",
    "createAlert": "Crear Alerta",
    "alert": "Alerta",
    "alerts": "Alertas",
    "deleteAlert": "Borrar Alerta",
    "nextAlert": "Siguiente Alerta: ",
    "lastAlert": "Última Alerta: ",
    "lastAlertNA": "N/A",
    "confirm": "Confirmar",
    "currently": "Actualmente: ",
    "abovePlaceholder": "arriba ",
    "belowPlaceholder": "abajo",
    "editAlert": "Editar Alerta",
    "intervalValue": "Valor del intervalo",
    "newAlert": "Nueva Alerta",
    "number": "Número",
    "minDropdownPlaceholder": "Cuando está arriba de _____ ",
    "maxDropdownPlaceholder": "Cuando está por debajo de _____ ",
    "setAlertLogic": "Establecer Lógica de Alerta",
    "setAlertLogicPlaceholder": "Seleccione una lógica de alerta",
    "optionalSettings": "Configuración opcional",
    "customLabelTitle": "Personalizar el título de la alerta",
    "blackoutDates": "¿Fechas de bloqueo?",
    "autoReset": "Restablecimiento automático",
    "autoResetDescription": "Restablece automáticamente el siguiente intervalo al enviar la rutina en la alerta de la actividad.",
    "alertDate": "Fecha de alerta",
    "alertTime": "Hora de la alerta",
    "startDate": "Fecha de inicio",
    "starting": "Comenzando",
    "minute": "minuto",
    "minutes": "minutos",
    "hour": "hora",
    "hours": "horas",
    "day": "día",
    "days": "días",
    "week": "semana",
    "weeks": "semanas",
    "month": "mes",
    "months": "meses",
    "togo": "faltan",
    "completions": "completado",
    "recorded": "grabado",
    "elapsed": "transcurrido",
    "OR": "O",
    "or": "o",
    "on": "en",
    "at": "a las",
    "skipped": "saltado",
    "every": "cada",
    "Every": "Cada",
    "startingValue": "Valor inicial",
    "intervalWindowPerAsset": "Intervalo por activo",
    "managedOnGroup": "Gestionada en el grupo: {{group}}",
    "noRoutinesOnGroup": "Este grupo no tiene rutinas asignadas. Asigne una rutina primero para configurar una alerta de grupo.",
    "managedOnGroupNote": "Esta alerta está configurada en el grupo {{group}}. Aquí solo se puede cambiar el punto de inicio de este activo.",
    "onDate": "En una fecha específica",
    "onDays": "Cada ___ días",
    "onRecurringInterval": "En un intervalo de tiempo recurrente",
    "onDayInterval": "Recuérdame después de ___",
    "onDayIntervalUnit": "Unidad",
    "dateInterval": {
      "minutes": "Minutos",
      "hours": "Horas",
      "days": "Días",
      "weeks": "Semanas",
      "months": "Meses"
    },
    "onDaysSkipped": "Cada ___ días la rutina está incompleta",
    "onRoutineCompletions": "Cada ___ veces se completa la rutina",
    "onInterval": "Basado en un intervalo",
    "selectRoutineToPrompt": "Seleccionar Rutina para Avisar",
    "selectAlertingLogic": "Seleccionar Lógica de Alerta",
    "customLabelWhenAlertOccurs": "Etiqueta Personalizada Cuando Ocurre la Alerta",
    "selectRoutine": "Seleccionar rutina",
    "reset": "Reiniciar",
    "edit": {
      "alertName": "Nombre de la alerta",
      "asset(s)": "Activo(s)",
      "assets": "Activos",
      "doNotAlert": "No alertar entre",
      "groups": "Grupos",
      "none": "Ninguno",
      "promptRoutine": "<0>Seleccione una rutina</0><1>para avisar con esta alerta</1>",
      "promptRoutinePlaceholder": "ninguna rutina seleccionada",
      "setFor": "Esta alerta está configurada para",
      "setOn": "Configurar la alerta en",
      "title": "Editar Alerta",
      "when": "Cuando"
    },
    "menu": {
      "confirmDelete": {
        "primaryButton": "Sí",
        "secondaryButton": "Cancelar",
        "title": "¿Está seguro de que desea eliminar {{alertName}}?"
      },
      "delete": "Eliminar",
      "disableAlert": "Desactivar alerta",
      "enableAlert": "Habilitar alerta",
      "viewAlertActivities": "Ver actividades de alerta"
    },
    "new": {
      "header": "Alertas > Crear Alerta"
    },
    "title": "Automatización",
    "trigger": {
      "counter": {
        "ceiling": "El contador va por encima",
        "daysSinceCompleted": "La rutina no se ha completado durante",
        "daysSinceCompleted-end": "Días",
        "every": "Cada",
        "every-end": "Días",
        "floor": "El contador va por debajo",
        "onCompletionCount": "La rutina se ha completado cada",
        "onCompletionCount-end": "Veces",
        "onInterval": "El contador alcanza el intervalo de"
      },
      "default": {
        "daysSinceCompleted": "La rutina no se ha completado durante",
        "daysSinceCompleted-end": "Días",
        "every": "Cada",
        "every-end": "Días",
        "onCompletionCount": "La rutina se ha completado cada",
        "onCompletionCount-end": "Veces"
      }
    },
    "validation": {
      "alertTypeRequired": "Tipo de alerta requerido",
      "inputRequired": "Entrada requerida",
      "invalidDate": "Fecha inválida",
      "startDateRequiredForDays": "Fecha de inicio requerida para el tipo de alerta de días",
      "routineIdRequiredForInterval": "Id de rutina requerido para el intervalo",
      "routineRequired": "Seleccione una rutina"
    },
    "setInterval": "Establecer intervalo",
    "numberOfDays": "Número de días",
    "numberOfTimes": "Número de veces"
  },
  "asset": {
    "activityExport": "Exportar Actividad",
    "advancedAssetInformation": "Información avanzada del activo",
    "customAlert": {
      "tagAlreadyAdded": "Esta etiqueta ya está agregada a este activo.",
      "tryAnotherTag": "Esta etiqueta ya está en uso y no se puede seleccionar. Pruebe con otra etiqueta."
    },
    "delete": {
      "button": "Eliminar activo",
      "cancel": "Cancelar",
      "confirm": "Eliminar",
      "title": "¿Está seguro de que desea eliminar este activo?"
    },
    "description": "Descripción",
    "descriptionPlaceholder": "Opcional",
    "details": "Detalles",
    "detailsPlaceHolder": "Opcional",
    "editTitle": "Información del activo",
    "information": "Información del activo",
    "groups": "Grupos",
    "groupsPlaceHolder": "(Opcional) Seleccionar grupo(s)",
    "groupsSearchPlaceHolder": "Buscar un nombre de grupo",
    "header": {
      "buttons": {
        "addNew": "Agregar Informe / Nota",
        "routines": "Rutinas",
        "addSomething": "Añade algo"
      },
      "recentActivity": "Actividad reciente",
      "activity": "Actividad",
      "addDescription": "Agregar descripción",
      "expandDescription": "Mostrar descripción completa",
      "collapseDescription": "Contraer descripción"
    },
    "mediaLibrary": "Biblioteca de medios",
    "name": "Nombre",
    "namePlaceholder": "¿Qué es esto?",
    "newIssue": "¿Algo nuevo?",
    "accessRequest": {
      "requestFull": "Solicitar Acceso Completo",
      "requested": "Acceso Solicitado",
      "modalTitle": "Solicitar Acceso Completo",
      "modalSubtitle": "Deja un mensaje para que el propietario del espacio de trabajo sepa por qué necesitas acceso.",
      "modalPlaceholder": "Mensaje opcional...",
      "modalSubmit": "Enviar Solicitud"
    },
    "newTitle": "Configuración de activos",
    "tagCode": "Gripp ID",
    "qr": {
      "title": "Código QR del Gripp ID",
      "viewQrLabel": "Ver código QR para {{tagCode}}",
      "tagAlt": "Etiqueta Gripp {{tagCode}}"
    },
    "assetPicture": "Tome una foto del activo",
    "newAsset": "Nuevo Activo",
    "assetName": "Nombre",
    "newAdditionalMedia": "Fotos",
    "submitError": "No se pudo guardar este activo. Inténtalo de nuevo.",
    "secondaryDescription": "Descripción",
    "optionalSetting": "Configuración opcional",
    "hideReportAndNoteOptionsAnonymous": "Ocultar opciones de informe y nota para visitantes anónimos",
    "hideReportAndNote": "Informe y Nota",
    "hideForAnonymousVisitors": "Ocultar para visitantes anónimos",
    "files": {
      "title": "Archivos",
      "noFiles": "No se encontraron archivos.",
      "addFilesLinks": "Agregar archivos / enlaces",
      "addSheetTitle": "Agregar",
      "addSheetSubtitle": "Archivo, multimedia o enlace",
      "uploadFile": "Subir archivo",
      "addLink": "Agregar enlace",
      "save": "Guardar",
      "addFile": "Agregar archivo",
      "view": "Ver {{count}} resultado",
      "view_plural": "Ver {{count}} resultados",
      "camera": "Cámara",
      "file": "Archivo",
      "unableToPreview": "No se puede previsualizar",
      "videoLoading": "Cargando vídeo…",
      "videoUnavailable": "Vídeo no disponible"
    },
    "detail": {
      "edit": "Editar",
      "delete": "Eliminar",
      "delete_asset": "Eliminar Activo",
      "delete_warning": "Esta acción no se puede deshacer.",
      "confirmDelete": "¿Está seguro de que desea eliminar el archivo {{fileName}}?"
    },
    "productType": "Tipo de producto",
    "serialNumber": "Número de serie",
    "addons": "Complementos ({{count}})",
    "addonsNoProduct": "Este activo no tiene tipo de producto. Asigne un producto para habilitar la selección de complementos.",
    "enterTagCode": "Ingresar código de etiqueta",
    "add": "Agregar",
    "cancel": "Cancelar",
    "save": "Guardar",
    "tagCodePlaceholder": "Ingresar código de etiqueta",
    "lookingUpTag": "Buscando etiqueta...",
    "pinnedActivity": "Actividad Fijada",
    "viewAll": "Ver Todo"
  },
  "assets": {
    "callDealer": "Llamar al distribuidor",
    "filter": {
      "title": "Filtros",
      "search": "Buscar",
      "recentSearches": "Búsquedas recientes",
      "apply": "Aplicar",
      "reset": "Reiniciar",
      "viewResults": "Ver {{count}} resultados",
      "notGrouped": "(sin grupo)",
      "columnButton": "Columnas",
      "columnSelection": "Columnas",
      "columns": {
        "createdAt": "Creado en",
        "createdBy": "Creado por",
        "description": "Descripción",
        "serialNumber": "Número de serie",
        "productName": "Nombre del Producto",
        "groups": "Grupos",
        "groupNames": "Nombres de Grupos",
        "lastAddress": "Ubicación",
        "lastScannedAt": "Último escaneado",
        "lastUpdated": "Última actualización",
        "name": "Nombre (requerido)",
        "notes": "# de Notas",
        "alerts": "# de Alertas",
        "reports": "# de Informes Activos",
        "routines": "# de Rutinas",
        "addons": "# de Complementos",
        "tagCode": "Gripp ID",
        "workspaces": "Espacio de trabajo"
      },
      "groups": "Grupos",
      "groupsButton": "Grupos",
      "default": "Predeterminado",
      "searchPlaceholder": "Buscar nombre, descripción, producto, add-ons o Gripp ID",
      "filterToggle": "Filtración combinada:",
      "combinedGroups": "Filtración combinada"
    },
    "groups": {
      "addAssetTo": "Añadir 1 activo a:",
      "addAssetsTo": "Añadir {{count}} activos a:"
    },
    "list": {
      "createdAt": "Creado en",
      "createdDate": "Fecha de creación",
      "createdTime": "Hora de creación",
      "createdBy": "Creado por",
      "description": "Descripción",
      "serialNumber": "Número de serie",
      "productName": "Nombre del Producto",
      "groups": "Grupos",
      "groupNames": "Nombres de Grupos",
      "lastAddress": "Ubicación",
      "lastScannedAt": "Último escaneado",
      "lastScannedDate": "Fecha del último escaneo",
      "lastScannedTime": "Hora del último escaneo",
      "lastUpdated": "Última actualización",
      "lastUpdatedDate": "Fecha de la última actualización",
      "lastUpdatedTime": "Hora de la última actualización",
      "name": "Nombre",
      "notes": "Notas",
      "assetAlerts": "Alertas de Activos",
      "groupAlerts": "Alertas de Grupo",
      "reports": "Informes activos",
      "routines": "Rutinas",
      "addons": "Complementos",
      "tagCode": "Gripp ID",
      "workspaces": "Espacio de trabajo"
    },
    "menu": {
      "title": "Activos",
      "titleSingular": "Activo"
    },
    "textEmpty": "Sin Activos",
    "topBar": {
      "allAssets": "Todos los activos",
      "assetSelected": "1 activo seleccionado",
      "assetsSelected": "{{count}} activos seleccionados",
      "results": "{{count}} resultados"
    },
    "change": "Cambiar",
    "routines": "Rutinas",
    "routineSearchPlaceholder": "Buscar nombre de rutina",
    "addonsSearchPlaceholder": "Buscar nombre del complemento"
  },
  "products": {
    "textEmpty": "Sin productos",
    "list": {
      "name": "Nombre"
    }
  },
  "avatar": {
    "menu": {
      "profile": "Perfil"
    }
  },
  "binaryCheck": {
    "button": "Actualizar",
    "instructions1": "¡Hay una nueva actualización disponible!",
    "instructions2": "Gripp puede no funcionar hasta entonces."
  },
  "camera": {
    "Cancel": "Cancelar",
    "grippInviteDetected": "¡Se ha detectado una invitación de Gripp!",
    "grippTagDetected": "¡Etiqueta Gripp detectada!",
    "noCameraAccess": "Sin acceso a la cámara",
    "notGrippInvite": "No es una invitación de Gripp",
    "notGrippTagg": "No es una etiqueta Gripp",
    "tryAgain": "Inténtalo de nuevo",
    "noPermissionModal": {
      "oopsMessage": "¡Uy! No tienes permiso para\nacceder a esta etiqueta Gripp. 🙈",
      "button": "¡Entendido!",
      "errorMessage": "Si crees que esto es un error, confirma que\nestás invitado al espacio de trabajo correcto o\ncontacta al soporte de Gripp."
    }
  },
  "changesSaved": "Cambios Guardados",
  "customAlert": {
    "ok": "DE ACUERDO"
  },
  "deleteAccount": {
    "button": "Eliminar cuenta",
    "cannotUndone": "Esta acción no se puede deshacer.",
    "confirm": "Confirmar Eliminación",
    "header": "Eliminar cuenta",
    "reasonInput": "Háganos saber cualquier detalle adicional para eliminar su cuenta (opcional):",
    "reasonInputNoOptional": "Háganos saber cualquier detalle adicional para eliminar su cuenta:",
    "submitted": "Se ha enviado su solicitud de eliminación de cuenta."
  },
  "dropdown": {
    "dropdownFooter": {
      "apply": "Aplicar",
      "reset": "Reiniciar"
    }
  },
  "edit": "",
  "email": "Correo electrónico",
  "features": {
    "title": "Características",
    "assignment": {
      "workspaces": "Espacios de trabajo",
      "accounts": "Cuentas",
      "workspaceSearchPlaceholder": "Buscar espacios de trabajo...",
      "accountSearchPlaceholder": "Buscar cuentas...",
      "noWorkspaces": "No se encontraron espacios de trabajo",
      "noAccounts": "No se encontraron cuentas",
      "name": "Nombre",
      "email": "Correo electrónico",
      "phone": "Teléfono"
    }
  },
  "campaigns": {
    "menu": {
      "title": "Campañas"
    },
    "page": {
      "title": "Campañas"
    },
    "list": {
      "empty": "No se encontraron campañas",
      "addCampaign": "Crear campaña"
    },
    "columns": {
      "name": "Nombre",
      "status": "Estado",
      "responses": "Respuestas",
      "groups": "Grupos",
      "products": "Productos",
      "serialNumber": "Número de serie",
      "lastUpdated": "Última actualización",
      "createdAt": "Creado en"
    },
    "create": {
      "panelTitle": "Nueva campaña"
    },
    "responses": {
      "panelTitle": "Respuestas"
    },
    "edit": {
      "panelTitle": "Editar campaña"
    }
  },
  "firstName": "Nombre",
  "forbidden": "Prohibido",
  "groups": {
    "groupsSelector": {
      "addToGroup": "Agregar al grupo",
      "addtoNewGroup": "Agregar a un nuevo grupo",
      "apply": "Aplicar",
      "clearGroups": "Borrar grupos"
    },
    "searchGroups": "Buscar grupos",
    "noGroups": "Sin grupos",
    "menu": {
      "title": "Grupos",
      "editGroup": "Editar Grupo"
    },
    "create": {
      "label": "Crear un Nuevo Grupo",
      "validation": {
        "name_required": "El nombre del grupo es obligatorio"
      },
      "create": "Crear",
      "placeholder": "Ej. Grupo de Tractores"
    },
    "list": {
      "name": "Nombre del Grupo",
      "people": "Personas",
      "assets": "Activos",
      "reports": "Informes Activos",
      "routines": "Rutinas",
      "assetAlerts": "Alertas de Activos",
      "groupAlerts": "Alertas de Grupo"
    },
    "common": {
      "textEmpty": "No hay grupos",
      "selectGroup": "Seleccionar grupos",
      "searchGroup": "Buscar grupos",
      "createGroup": "Crear Grupo",
      "emptyStateMessage": "Crear un grupo escribiendo directamente en la barra de búsqueda.",
      "labelsApplied": "Etiquetas aplicadas"
    },
    "filter": {
      "searchPlaceholder": "Buscar nombre de grupos",
      "columnButton": "Columnas",
      "columns": {
        "name": "Nombre del grupo",
        "reports": "Informes activos",
        "assets": "Activos",
        "people": "Personas",
        "routines": "Rutinas",
        "assetAlerts": "Alertas de Activos",
        "groupAlerts": "Alertas de Grupo"
      },
      "columnSelection": "Selección de columnas"
    },
    "assignments": {
      "name": "Nombre",
      "jobTitle": "Título profesional",
      "accountType": "Tipo de cuenta",
      "assetSearchPlaceholder": "Buscar nombre de equipo, descripción o nombre de grupo",
      "accountSearchPlaceholder": "Buscar nombre de persona o titulo",
      "routineSearchPlaceholder": "Buscar nombre de rutina",
      "groupSearchPlaceholder": "Buscar nombres de grupos",
      "addonsSearchPlaceholder": "Buscar nombre del complemento",
      "emptyAccountList": "No hay cuentas",
      "assets": "Activos",
      "groups": "Grupos",
      "people": "Personas",
      "routines": "Rutinas"
    },
    "deleteGroup": {
      "deleteGroup": "Borrar Grupo",
      "alertBody1": "Estas seguro que quieres borrar",
      "alertBody2": "Nota: ",
      "alertBody3": "Esto no eliminará ningún activo asociado con este ",
      "alertBody4": "grupo.",
      "delete": "Borrar",
      "cancel": "Cancelar",
      "toastTitle": "¡Hecho!",
      "toastMessage": "{{groupName}} ha sido eliminado."
    }
  },
  "help": {
    "menu": {
      "title": "Ayuda"
    }
  },
  "alertsManagement": {
    "menu": {
      "editAlert": "Editar alerta"
    },
    "filter": {
      "searchPlaceholder": "Buscar alertas...",
      "columnButton": "Columnas",
      "columnSelection": "Selección de Columnas",
      "columns": {
        "name": "Nombre",
        "routineName": "Rutina",
        "assetName": "Activo",
        "groupName": "Grupo",
        "productName": "Producto",
        "assetAlerts": "Alertas de Activos",
        "lastAlertDate": "Última Alerta",
        "nextAlertDate": "Próxima Alerta",
        "createdAt": "Creado",
        "status": "Estado"
      },
      "status": {
        "label": "Estado",
        "all": "Todos",
        "enabled": "Habilitado",
        "disabled": "Deshabilitado"
      }
    },
    "common": {
      "textEmpty": "No se encontraron alertas"
    },
    "list": {
      "name": "Nombre",
      "routineName": "Rutina",
      "assetName": "Activo",
      "groupName": "Grupo",
      "productName": "Producto",
      "assetAlerts": "Alertas de Activos",
      "lastAlertDate": "Última Alerta",
      "nextAlertDate": "Próxima Alerta",
      "createdAt": "Creado",
      "status": "Estado"
    },
    "deleteAlert": {
      "deleteAlert": "Eliminar alerta",
      "alertBody1": "¿Está seguro de que desea eliminar",
      "alertBody2": "Advertencia:",
      "alertBody3": " Eliminar esta alerta la eliminará permanentemente junto con todos los datos asociados.",
      "delete": "Eliminar",
      "cancel": "Cancelar"
    },
    "actions": {
      "enable": "Habilitar",
      "disable": "Deshabilitar",
      "enableSuccess": "Se habilitó exitosamente {count} alerta(s)",
      "disableSuccess": "Se deshabilitó exitosamente {count} alerta(s)"
    }
  },
  "invitation": {
    "initial": {
      "heading": "¡Estás invitado a {{workspaceName}}!",
      "login": "Clave de inicio de sesión",
      "step1": "Paso 1",
      "step1Instructions": "Descargar la aplicación Gripp",
      "step2": "Paso 2",
      "step2Instructions": "Utilice esta clave para iniciar sesión"
    },
    "invitePeople": {
      "copiedInvitationLink": "Enlace de invitación copiado",
      "copyInviteLink": "Copiar enlace de invitación",
      "shareInviteLink": "Compartir enlace de invitación",
      "errorCopyingInvitationLink": "Algo salió mal al copiar la URL de la invitación.",
      "invitePeopleForm": "Invitar personas a través de correos electrónicos",
      "invitePeopleQR": "Invitar personas a través del código QR",
      "linkAllowsToJoinWorkplace": "Este enlace permite que cualquiera solicite unirse a su lugar de trabajo.",
      "emailPlaceholder": "Correo electrónico",
      "inviteViaEmailLabel": "Invitar por correo electrónico",
      "inviteSentSuccess": "Invitación enviada correctamente",
      "inviteSentError": "Algo salió mal al enviar la invitación",
      "placeholder": "Correos electrónicos",
      "send": "Enviar",
      "submit": "Entregar",
      "to": "Para"
    },
    "pending": {
      "accepted": "Siga el enlace enviado a su correo electrónico para iniciar sesión en su cuenta Gripp.",
      "cancel": "Cancelar",
      "join": "Unirse",
      "joining": "Te estás uniendo a {{workspaceName}}",
      "title": "Crear perfil"
    },
    "qr": {
      "invitesYou": "te invita a unirte",
      "showQr": "Mostrar QR para invitar a otros"
    }
  },
  "issue": {
    "footer": {
      "clearStatus": "Borrar estado",
      "attachmentFailed": "No se pudo adjuntar el archivo. Inténtalo de nuevo.",
      "bold": "Negrita",
      "bulletList": "Lista con viñetas",
      "italic": "Cursiva",
      "link": "Enlace",
      "orderedList": "Lista numerada",
      "strikethrough": "Tachado",
      "textStyles": "Estilos de texto",
      "underline": "Subrayado"
    },
    "anonymous": {
      "addNote": "Añadir la nota",
      "createReport": "Crear reporte",
      "getGrippCta": "Obtén Gripp para ver la actividad, los archivos y unirte a la conversación.",
      "noteAdded": "¡Nota agregada!",
      "noteAddedDownloadGrippApp": "¡Descarga la app de Gripp para tomar notas aún más fácilmente!",
      "openAppStore": "Abrir App Store",
      "report": "Informe",
      "reportAddedDownloadGrippApp": "¡Descarga la app de Gripp para hacer informes aún más rápido!",
      "reported": "¡Problema reportado!",
      "routineCompleted": "¡Boom, actualización confirmada!",
      "routineCompletedDownloadGrippApp": "¡Descarga la app de Gripp para disfrutar de la mejor experiencia!",
      "dropRoutineTitle": "¡Listo!",
      "dropRoutineSubtitle": "Continúa en Gripp para escanear, reportar y ver el historial más rápido.",
      "dropReportTitle": "Mantente al tanto.",
      "dropReportSubtitle": "Continúa en Gripp para ver respuestas, agregar más notas y ver más información.",
      "dropCta": "Obtener la app",
      "dropCtaA11yLabel": "Obtener la app de Gripp"
    },
    "common": {
      "addPicture": "Fotos",
      "addMedia": "Fotos y vídeos",
      "description": "Descripción",
      "followUp": "¿Requiere seguimiento?",
      "note": "No, solo lo apunto como referencia",
      "report": "Sí, se necesita seguimiento",
      "addLabel": "Agregar una Etiqueta",
      "labelSubtitle": "Para búsqueda y filtrado más fácil.",
      "selectLabel": "Seleccionar una etiqueta",
      "searchLabel": "Buscar una etiqueta",
      "createLabel": "Crear etiqueta",
      "emptyStateMessage": "Crear una etiqueta escribiendo directamente en la barra de búsqueda."
    },
    "delete": {
      "confirm": "¿Confirmar eliminación?",
      "button": "Eliminar Issue",
      "warning": "Esta acción no se puede deshacer.",
      "cancel": "Cancelar",
      "title": "Eliminar Actividad"
    },
    "editModal": {
      "header": "Editar",
      "save": "Guardar",
      "reviseSubmission": "Revisar envío",
      "pinDescription": "La actividad fijada se muestra en los detalles del activo"
    },
    "accessRequest": {
      "workspaceAccessRequest": "Solicitud de acceso al espacio de trabajo: {{message}}",
      "requestingFullAccess": "Solicitando acceso completo al espacio de trabajo.",
      "approve": "Aprobar",
      "deny": "Denegar",
      "approveA11y": "Aprobar solicitud de acceso",
      "denyA11y": "Denegar solicitud de acceso"
    },
    "message": {
      "anonymousGuestOf": "Anónimo (invitado de {{sharer}})",
      "anonymousGuestSignInA11y": "Inicia sesión para reclamar este mensaje"
    },
    "latestMessage": {
      "media": "[Medios]"
    },
    "menu": {
      "delete": "Borrar",
      "edit": "Editar",
      "editRoutine": "Editar rutina",
      "pinToAsset": "Fijar al activo",
      "print": "Imprimir",
      "reassign": "Reasignar",
      "reminder": "Recordatorios",
      "unpin": "Desfijar",
      "unpinToAsset": "Desfijar del Activo"
    },
    "new": {
      "addIt": "Agregar Informe / Nota",
      "editActivity": "Editar Actividad",
      "labels": "Etiquetas",
      "optionalPlaceholder": "Opcional",
      "placeholder": "¿Qué estas viendo?",
      "reassign": "Reasignar",
      "reminder": "Recordatorio",
      "reminderFailed": "Informe guardado, pero no se pudo configurar el recordatorio.",
      "submit": "Entregar",
      "submitError": "No se pudo guardar este informe. Inténtalo de nuevo.",
      "title": "Título",
      "type": "Tipo"
    },
    "quickReminder": {
      "header": "Establecer Recordatorio",
      "subheader": "Para programar este reporte para una fecha futura."
    },
    "adjustCreationDate": {
      "header": "Ajustar Fecha de Creación"
    },
    "createdDate": {
      "header": "Fecha de Creación"
    },
    "types": {
      "attention": "Urgente",
      "urgent": "Urgente",
      "blocker": "Pendiente",
      "pending": "Pendiente",
      "done": "Resuelto",
      "solved": "Resuelto",
      "routines": "Rutinas",
      "note": "Nota",
      "campaign": "Campaña"
    },
    "advancedSettings": "Configuración Avanzada",
    "dateFormat": "MM/DD/AAAA",
    "reminderFor": "Recordatorio para:",
    "reminderDate": "Fecha del recordatorio",
    "reminderTime": "Hora del recordatorio",
    "reassign": {
      "instructions": "¿A cuál de los siguientes activos desea reasignar?",
      "placeholder": "Buscar un nombre de activo",
      "saveLabel": "Guardar",
      "title": "Reasignar",
      "unassigned": "{{workspace}} (Sin asignar)"
    },
    "topBar": {
      "allReplies": "respuestas"
    },
    "reminder": {
      "notesOptional": "Notas (Opcional)",
      "scheduled": "Recordatorio Programado"
    },
    "location": {
      "deniedTitle": "Se necesita acceso a la ubicación",
      "deniedMessage": "Permite el acceso a la ubicación para Gripp en los ajustes de tu dispositivo para compartir dónde estás.",
      "unavailableTitle": "No se pudo obtener tu ubicación",
      "unavailableMessage": "No se pudo determinar ninguna posición en este momento. Muévete a un lugar con mejor señal e inténtalo de nuevo."
    }
  },
  "job": "Título profesional",
  "jobTitle": "Título profesional",
  "lastName": "Apellido",
  "loading": "Cargando",
  "login": {
    "codeSentTo": "Se envió un código de inicio de sesión a",
    "email": "Correo electrónico",
    "error": {
      "invalidCredentials": "Credenciales no válidas",
      "processError": "Hubo un error al procesar su solicitud"
    },
    "login": "Iniciar sesión",
    "password": "Contraseña",
    "resendCode": "Reenviar codigo",
    "tabs": {
      "new": {},
      "returning": {
        "title": "Estoy volviendo"
      }
    },
    "tryAnotherMethod": "Prueba otro método",
    "withEmail": "Continuar con el correo electrónico",
    "withPassword": "Tengo contraseña",
    "withPhone": "Continuar con el teléfono",
    "continue": "Continuar",
    "skip": "Saltar",
    "verify": "Verificar",
    "didntReceiveCode": "¿No recibiste un código?",
    "welcome": "Bienvenido",
    "signUpToContinue": "Regístrate para continuar",
    "orUsePrefix": "o usa",
    "toggleEmail": "el correo electrónico",
    "togglePhone": "el teléfono",
    "smsConfirmationMessage": "Te enviaremos un mensaje de texto para confirmar tu número. Puede tomar unos segundos.",
    "emailConfirmationMessage": "Te enviaremos un código de verificación para confirmar tu correo electrónico. Puede tomar unos segundos.",
    "verifyCodeSentTo": "Se envió un código a",
    "aboutYourself": "¡Cuéntanos sobre ti!",
    "existingAccount": "¿Ya tienes una cuenta de Gripp?"
  },
  "logout": "Cerrar sesión",
  "common": {
    "back": "Atrás",
    "cancel": "Cancelar",
    "ok": "Aceptar",
    "close": "Cerrar",
    "create": "Crear",
    "download": "Descargar",
    "reset": "Restablecer",
    "apply": "Aplicar",
    "save": "Guardar",
    "optional": "Opcional",
    "value": "Valor",
    "delete": "Eliminar",
    "confirmDelete": "Eliminar {{name}}",
    "deleteWarning": "Esta acción no se puede deshacer.",
    "next": "Siguiente",
    "remove": "Quitar",
    "typeMessage": "Escribir mensaje...",
    "message": "Mensaje",
    "filter": "Filtro",
    "searchOrCreate": "Buscar o crear nuevo",
    "filterSearch": {
      "placeholder": "Buscar filtros",
      "noResults": "Ningún filtro coincide con \"{{query}}\""
    },
    "groupAssignments": "Asignaciones de grupo"
  },
  "errorBoundary": {
    "title": "¡Ups!",
    "message": "Ocurrió un error inesperado.",
    "tryAgain": "Intentar de nuevo"
  },
  "mentions": {
    "unknownUser": "Usuario desconocida",
    "youAreMentioned": "Te mencionaron"
  },
  "media": {
    "validation": {
      "unsupported": "No se pudo subir este archivo. Puede estar dañado o en un formato no compatible."
    },
    "picker": {
      "tooMany": "Puedes agregar hasta {{count}} archivos a la vez. Solo se agregaron los primeros {{count}}."
    }
  },
  "modalMessages": {
    "completed": "Completada"
  },
  "or": "o",
  "onboarding": {
    "shareInfo": "¡Comparte más sobre ti con Gripp!",
    "industrial": "Campo industrial",
    "source": "¿Cómo escuchaste acerca de Gripp?",
    "agriculture": "Agricultura"
  },
  "people": {
    "menu": {
      "people": "Personas"
    }
  },
  "phone": "Teléfono",
  "plusMenu": {
    "add-asset": "Agregar activo",
    "invite": "Invitar",
    "no-tag": "¿Sin etiqueta?",
    "note": "Nota",
    "report": "Informe",
    "scan": "Escanear"
  },
  "preferences": {
    "appearance": {
      "title": "Tema",
      "system": "Sistema",
      "systemDescription": "Seguir la configuración de tu sistema operativo.",
      "light": "Claro",
      "lightDescription": "Paleta Crop Circle predeterminada.",
      "dark": "Oscuro",
      "darkDescription": "Paleta que reduce la fatiga visual para entornos con poca luz.",
      "more": "Más",
      "moreComingSoon": "Los controles de tamaño de fuente, densidad y movimiento reducido llegarán pronto."
    },
    "language": {
      "languages": {
        "english": "Inglés",
        "spanish": "Español",
        "russian": "Ruso",
        "kazakh": "Kazajo",
        "afrikaans": "Afrikáans",
        "portuguese": "Portugués",
        "french": "Francés"
      },
      "language": "Idioma",
      "preferredLanguageTitle": "Idioma preferido"
    },
    "menu": {
      "title": "Ajustes"
    },
    "settings": {
      "integrations": "Integraciones",
      "appearance": "Apariencia",
      "notifications": "Notificaciones",
      "permissions": "Permisos",
      "profile": "Perfil",
      "title": "Configuración",
      "workSpaces": "Espacios de trabajo",
      "workspace_settings": "Configuración de espacios de trabajo"
    },
    "permissions": {
      "title": "Permisos",
      "allow": "Permitir",
      "location": {
        "label": "Servicios de ubicación",
        "description": "Gripp usa la ubicación de tu teléfono para actualizar la ubicación de tus activos cuando los escaneás. Como mínimo, te pedimos que permitas la ubicación mientras usás la app."
      },
      "camera": {
        "label": "Acceso a la cámara",
        "description": "Hacer notas y reportar problemas a menudo requiere tomar una foto de lo que ves, por lo que habilitar el acceso a la cámara es importante para mantenerte a vos y a otros actualizados."
      },
      "gallery": {
        "label": "Acceso a la biblioteca de fotos",
        "description": "Similar a la cámara, a veces ya tenés fotos que querés subir a Gripp. Solo tendremos acceso a las fotos que elijas al momento de subirlas."
      },
      "pushNotifications": {
        "label": "Notificaciones push",
        "description": "Como muchas apps, recibí notificaciones cuando llegue una nueva alerta, problema o reporte. No te querrás perder nada importante."
      },
      "feature": {
        "scanner": "Se requiere acceso a la cámara para escanear códigos QR y agregar fotos a notas y reportes.",
        "gallery": "Se requiere acceso a la biblioteca de fotos para subir imágenes desde tu galería a notas y reportes."
      }
    },
    "notifications": {
      "activityLabelNotificationsTitle": "Notificaciones por etiquetas de actividad",
      "groupNotificationsTitle": "Notificaciones por grupo",
      "campaignMessages": "Nuevas Campañas",
      "issueReplies": "Mensajes",
      "notificationTitle": "Notificaciones",
      "schedule": {
        "accept": "Aceptar",
        "cancel": "Cancelar",
        "endTime": "Hora de finalización:",
        "everyDay": "Cada día",
        "notSet": "No establecido",
        "notificationSchedule": "Calendario de notificaciones",
        "set": "Colocar",
        "startTime": "Hora de inicio:",
        "weekDays": "Días de la semana"
      },
      "severities": {
        "blue": "Nuevas Rutinas",
        "purple": "Nuevas Notas",
        "red": "Nuevos Reportes"
      }
    }
  },
  "profile": {
    "edit": {
      "menu": {
        "title": "Editar Perfil"
      },
      "impersonate": {
        "impersonate": "Personificar",
        "unimpersonate": "Cancelar suplantación"
      },
      "error": {
        "title": "Error al actualizar el perfil",
        "generic": "Hubo un error al actualizar el perfil.",
        "duplicatedPhone": "Este número de teléfono ya está asociado con otra cuenta."
      }
    },
    "admin": {
      "title": "Suplantación",
      "workspace": "Espacio de trabajo",
      "workspaceUsers": "Usuarios del espacio de trabajo"
    }
  },
  "recent_activities": "Actividades recientes",
  "reminders": {
    "deleteReminder": "Eliminar Recordatorio",
    "setNewReminder": "establecer un nuevo recordatorio para"
  },
  "requestRoutine": {
    "apply": "Aplicar",
    "header": "Rutina",
    "instruction": "Por favor envíe su idea de rutina:",
    "placeHolder": "¿Qué deberíamos empezar a hacer?"
  },
  "routines": {
    "admin": {
      "create": "Guardar",
      "instructions": "Instrucciones",
      "issuePrefix": "Prefijo de problema",
      "reportOnException": "¿Informe sobre excepción?",
      "routineButtonText": "Botón de rutina",
      "title": "Título",
      "type": "Tipo",
      "oneTimeOnly": "Solo una vez",
      "autoPrompt": "Solicitar automáticamente al abrir activo",
      "idpEnabled": "Habilitar envío IDP",
      "idpDocumentDescription": "Describa el documento para la extracción por IA",
      "idpDocumentDescriptionHint": "Opcional. Oculto para los operadores: indica a la IA qué documento está leyendo antes de buscar los campos individuales.",
      "isWorkspaceRoutine": "Rutina de Espacio de Trabajo",
      "workspaceRoutineBadge": "Espacio de Trabajo",
      "update": "Actualizar",
      "addMedia": "Añadir Media",
      "image": "Imagen",
      "video": "Vídeo",
      "link": "Enlace",
      "linkLabel": "Agregar Enlace",
      "linkUrl": "Enlace",
      "linkUrlPlaceholder": "Ingresar la Enlace (ej., https://example.com)",
      "invalidUrl": "Enlace invalida",
      "removeMedia": "Eliminar multimedia",
      "enableAutoPinning": "Habilitar fijación automática al activo",
      "autoAddLabel": "Agregar automáticamente una etiqueta"
    },
    "assign": "Asignar rutinas",
    "copyToWorkspace": {
      "save": "Copiar",
      "title": "Copiar al espacio de trabajo",
      "workspace": "Espacio de trabajo"
    },
    "counter": {
      "admin": {
        "decimalPlaces": "Habilitar decimales (opcional)",
        "tallyCounter": "Contador de Cuentas",
        "uom": "Unidad de medida",
        "counterType": "Tipo de contador"
      },
      "user": {
        "integrationManaged": "Gestionado por {{provider}} — se actualiza automáticamente",
        "genericCounter": {
          "change": "Cambiar:",
          "initialValue": "Valor inicial:",
          "newValue": "Nuevo valor:"
        },
        "tallyCounter": {
          "add": "+ Agregar",
          "added": "Agregardo",
          "adding": "Añadiendo:",
          "instructions": "¿Cuántas unidades quieres agregar o quitar?",
          "newValue": "Nuevo valor:",
          "oldValue": "Valor Anterior:",
          "placeholder": "Introducir número...",
          "remove": "- Eliminar",
          "removed": "Eliminado",
          "removing": "Eliminando:"
        }
      },
      "counterTypes": {
        "CUMULATIVE": "Acumulativo",
        "SIMPLE": "Simple",
        "TALLY": "Cuenta"
      }
    },
    "time": {
      "admin": {
        "time": "Tipo de tiempo",
        "labelStartTime": "Tiempo de inicio",
        "labelEndTime": "Tiempo de fin"
      },
      "timeTypes": {
        "START_END_TIMES": "Tiempo de inicio y finalización",
        "TIME_ONLY": "Solo tiempo",
        "DATE_ONLY": "Solo fecha",
        "TIME_AND_DATE": "Fecha y hora"
      },
      "message": {
        "time": "Time",
        "start": "Inicio",
        "end": "Fin",
        "date": "Fecha"
      }
    },
    "download": {
      "noDataTitle": "Nada para descargar",
      "noDataMessage": "Las rutinas seleccionadas no tienen datos para las fechas elegidas."
    },
    "createNew": "Crear nueva rutina",
    "edit": {
      "header": "Rutinas > Editar rutina",
      "title": "Editar rutina"
    },
    "editRoutines": {
      "editRoutinesButton": "Editar Rutinas",
      "label": "Etiqueta:",
      "routineInWorkplace": "Todas las rutinas disponibles en su lugar de trabajo",
      "title": "Editar",
      "saveSuccess": "Rutinas actualizadas correctamente",
      "saveError": "Error al guardar las rutinas",
      "routineAdded": "La rutina {{title}} ha sido agregada",
      "routineRemoved": "La rutina {{title}} ha sido removida",
      "routineReordered": "Rutinas reordenadas exitosamente"
    },
    "exceptions": {
      "addDetails": "Agregue detalles adicionales o imágenes del problema:",
      "exceptionsNoticed": "{{count}} excepción detectada",
      "exceptionsNoticed_plural": "{{count}} excepciones detectadas",
      "reportCreated": "Se creó un informe",
      "viewRelatedReport": "Ver informe relacionado",
      "viewRelatedRoutine": "Ver rutina relacionada"
    },
    "header": {
      "title": "Rutinas",
      "view": "Ver",
      "viewAll": "Ver todo"
    },
    "menu": {
      "copyToWorkspace": "Copiar al espacio de trabajo",
      "delete": {
        "cancel": "Cancelar",
        "confirm": "Sí",
        "item": "Borrar",
        "title": "¿Estás seguro de que deseas eliminar esta rutina?",
        "blockedTitle": "Rutina en uso",
        "blockedGeneric": "No se pudo eliminar esta rutina. Inténtalo de nuevo."
      },
      "download": "Descargar",
      "editRoutine": "Editar rutina",
      "export": "Exportar datos",
      "exporting": "Exportador..."
    },
    "message": {
      "messageTitle": "{{name}} rutina completada:",
      "added": "agregado",
      "removed": "suprimido",
      "originalValue": "Valor original",
      "newValue": "Nuevo valor",
      "messageTitleUpdated": "{{name}} realizó una actualización",
      "idp": {
        "extracting": "Extrayendo…",
        "takingLonger": "La extracción por IA está tardando más de lo esperado.",
        "editLocked": "La extracción por IA está en curso — esta presentación no se puede editar hasta que finalice."
      }
    },
    "modalCancel": {
      "primary": "Salir sin guardar.",
      "secondary": "Cancelar",
      "title": "Antes de volver,"
    },
    "draftModal": {
      "continueDraft": "Continuar borrador.",
      "startNew": "Comenzar una nueva rutina.",
      "cancel": "Cancelar",
      "messageNoDraft": "Se guardó un borrador",
      "messageWithoutCreator": "Se guardó un borrador el {{date}}",
      "messageWithCreator": "Se guardó un borrador por: \n{{creator}} el {{date}}"
    },
    "new": {
      "chooseTypeButton": "Siguiente paso: elegir opciones",
      "header": "Rutinas > Crear rutina",
      "title": "Crear rutina"
    },
    "quickConfirm": {
      "admin": {
        "addOption": "Agregar opción",
        "options": "Opciones"
      }
    },
    "requestButton": "+ Solicitar Rutina",
    "signature": {
      "clear": "Claro",
      "done": "Hecho",
      "sign": "Firmar",
      "signature": "Firma",
      "submit": "Entregar"
    },
    "status": {
      "admin": {
        "addStatus": "Agregar estado",
        "statuses": "Estados",
        "openEndedResponse": "Respuesta abierta",
        "otherStatus": "Otro _______"
      }
    },
    "submit": "Entregar",
    "resubmit": "Reenviar",
    "saveDraft": "Guardar como borrador",
    "submitError": "No se pudo guardar esta rutina en tu dispositivo. Inténtalo de nuevo.",
    "types": {
      "COUNTER": "Encimera",
      "QUICK_CONFIRM": "Confirmación rápida",
      "STATUS": "Estado",
      "WORKFLOW": "Mini formulario"
    },
    "update": "Actualizar",
    "workflow": {
      "admin": {
        "page": {
          "addQuestion": "Agregar pregunta",
          "duplicateQuestion": "Duplicada pregunta",
          "instructions": "Instrucciones",
          "page": "Página {{página}}",
          "questionType": "tipo de pregunta",
          "deleteQuestion": "Eliminar pregunta"
        },
        "question": {
          "addOption": "Agregar opción",
          "exception": {
            "HasResponse": "Tiene respuesta",
            "MissingResponse": "Respuesta faltante",
            "Off": "Apagado",
            "label": "Manejo de excepciones:"
          },
          "instructions": "Instrucciones",
          "multiline": "Multilínea",
          "options": "Opciones",
          "question": "Pregunta {{pregunta}}",
          "barcodeScanner": {
            "allowMultiple": "Permitir múltiples entradas",
            "includeQuantity": "Incluir campo de cantidad",
            "includeMemo": "Incluir campo de notas"
          },
          "location": {
            "includeMemo": "Incluir campo de notas"
          },
          "idpSource": "Documento IDP: fijado",
          "idpSourceInstructions": "Fotografíe o cargue el documento del que se extraerán los datos.",
          "idpSourceImageOnly": "Bloqueado mientras IDP está activado: solo admite imágenes, no video.",
          "idpManaged": "Gestionado por IDP",
          "idpPrompt": "Describa este campo para la extracción por IA",
          "idpPromptHint": "Oculto para los operadores: se completa automáticamente a partir del documento.",
          "idpPromptRequired": "Se requiere una instrucción para los campos gestionados por IA.",
          "idpManagedCapReached": "Se alcanzó el límite de 100 campos gestionados por IDP."
        },
        "routine": {
          "label": "Rutina",
          "select": "Selecciona una rutina"
        }
      },
      "execution": {
        "optional": "Opcional",
        "submit": "Entregar",
        "barcodeScanner": {
          "addAnother": "Agregar otro:",
          "placeholder": "Ingrese o escanee un código de barras",
          "placeholderManual": "Ingrese un código de barras",
          "quantityPlaceholder": "Cant.",
          "quantityLabel": "Cant.: {{quantity}}",
          "remove": "Eliminar entrada",
          "scan": "Escanear código de barras",
          "memoPlaceholder": "Nota"
        },
        "location": {
          "placeholder": "Toque para capturar ubicación",
          "captureLabel": "Capturar ubicación actual",
          "memoPlaceholder": "Agregar una nota..."
        },
        "media": {
          "idpImageRequired": "Se requiere al menos una imagen para la extracción por IA."
        }
      },
      "questionTypes": {
        "CHECKBOX": "Selección múltiple",
        "COUNTER": "Encimera",
        "MEDIA": "Medios de comunicación",
        "QUICK_CONFIRM": "Confirmación rápida",
        "RADIO": "Selección única",
        "ROUTINE": "Rutina",
        "SIGNATURE": "Firma",
        "STATUS": "Estado",
        "TEXT": "Texto",
        "TIME": "Tiempo",
        "LABEL": "Etiqueta",
        "BARCODE_SCANNER": "Escáner de códigos de barras",
        "LOCATION": "Ubicación"
      }
    },
    "textEmpty": "Sin rutinas",
    "addToGroups": "Agregar a Grupos",
    "addToGroupsDescription": "Asignar {{count}} rutinas seleccionadas a grupos",
    "list": {
      "name": "Nombre",
      "type": "Tipo",
      "groups": "Grupos"
    }
  },
  "saveChanges": "Guardar Cambios",
  "unsavedChanges": {
    "title": "Cambios no guardados",
    "subtitle": "¿Deseas guardar tu progreso antes de continuar?",
    "saveAndExit": "Guardar y salir",
    "dontSave": "No guardar"
  },
  "signOut": "Desconectar",
  "support": {
    "genericDescription": "A veces pasan cosas, pero si vuelves a ver esta página, avísanos para que podamos arreglarlo.",
    "sendEmail": "O envíame un correo electrónico a",
    "title": "Vaya, nos hemos equivocado."
  },
  "tags": {
    "assetName": "Nombre del activo",
    "batches": {
      "title": "Etiquetar lotes"
    },
    "status": "Estado",
    "tagCode": "Número de etiqueta",
    "title": "Etiquetas",
    "updatedAt": "Actualizado En",
    "version": "Versión"
  },
  "textEmptyList": "Sin datos",
  "topNav": {
    "activities": "Actividad",
    "add": "Agregar",
    "assetInfo": "Ver activo",
    "assets": "Activos",
    "back": "Atrás",
    "backButton": {
      "cancel": "Continua editando",
      "confirmBack": "¡Hay cambios sin guardar!",
      "ok": "Salir sin guardar"
    },
    "cancel": "Cancelar",
    "customAlert": {
      "cancel": "Cancelar",
      "deleteAccount": "¿Salir sin guardar?",
      "exit": "¿Salir sin guardar?",
      "signOut": "¿Estás seguro de que te gustaría salir?",
      "yes": "Sí",
      "saveProgress": "Guardar para más tarde."
    },
    "edit": "Editar",
    "editAsset": "Información del activo",
    "invite": "Invitar a la gente",
    "moreAssetInfo": "Más información",
    "moreWorkspaceInfo": "Más información del espacio de trabajo",
    "save": "Guardar",
    "myHistory": "Mi historial",
    "modify": "Modificar"
  },
  "translation": {
    "seeOriginal": "Ver original",
    "seeTranslation": "Ver traducción"
  },
  "versionCheck": {
    "description": "¡Actualizaciones disponibles! Es posible que algunas funciones no funcionen hasta que actualice el navegador.",
    "refreshButton": "Refrescar"
  },
  "offline": {
    "banner": {
      "title": "Estás sin conexión"
    },
    "unavailable": {
      "title": "No disponible sin conexión"
    },
    "tagUnavailable": {
      "title": "Esta etiqueta no está disponible sin conexión",
      "back": "Volver"
    },
    "submitDisabled": "Conéctate a internet para enviar.",
    "groupCreateDisabled": "Conéctate a internet para crear un grupo.",
    "labelCreateDisabled": "Conéctate a internet para crear una etiqueta.",
    "signOutDisabled": "Conéctate a internet para cerrar sesión.",
    "pending": {
      "tag": "Pendiente",
      "notSynced": "No sincronizado",
      "notSyncedAction": "Ver por qué no se sincronizó este elemento"
    },
    "sync": {
      "progress": "Sincronizando {{current}} de {{total}}…",
      "signIn": "Inicia sesión de nuevo para terminar de sincronizar.",
      "lockedHint": "Sincronizando…",
      "lockedSettings": "Disponible cuando este activo se haya sincronizado",
      "failedToast": "No se pudo sincronizar {{count}} elemento",
      "failedToast_plural": "No se pudieron sincronizar {{count}} elementos"
    },
    "guard": {
      "title": "Tienes {{count}} elemento sin sincronizar",
      "title_plural": "Tienes {{count}} elementos sin sincronizar",
      "message": "Estos cambios aún no han llegado al servidor. Sincronízalos primero o descártalos para continuar.",
      "stuck": "Algunos elementos no se pueden sincronizar desde aquí: fallaron, pertenecen a otro espacio de trabajo o necesitan una versión más reciente de la app. Descártalos o cancela.",
      "offline": "Conéctate a internet para sincronizar.",
      "syncNow": "Sincronizar ahora",
      "discard": "Descartar",
      "cancel": "Cancelar",
      "syncing": "Sincronizando…"
    },
    "item": {
      "title": "No sincronizado",
      "reason": "No se pudo enviar este elemento.",
      "waiting": "Este elemento necesita una versión más reciente de la app.",
      "deferred": "Cambia a su espacio de trabajo para enviarlo.",
      "discardError": "No se pudo descartar este elemento. Inténtalo de nuevo.",
      "retry": "Reintentar",
      "discard": "Descartar",
      "close": "Cerrar",
      "kind": {
        "ensureMedia": "Foto",
        "createAssetRoutine": "Rutina",
        "reportIssue": "Informe de incidencia",
        "createReminderWorkflow": "Recordatorio",
        "addAsset": "Activo"
      }
    },
    "age": {
      "minutes": "hace {{count}} minuto",
      "minutes_plural": "hace {{count}} minutos",
      "hours": "hace {{count}} hora",
      "hours_plural": "hace {{count}} horas",
      "days": "hace {{count}} día",
      "days_plural": "hace {{count}} días"
    },
    "copy": {
      "strip": "Mostrando datos de {{age}}",
      "stripUndated": "Mostrando datos guardados",
      "stripHint": "Abre la configuración sin conexión",
      "olderActivity": "La actividad anterior está disponible con conexión",
      "filtered": "Borra tu búsqueda y filtros para ver la actividad guardada."
    },
    "settings": {
      "title": "Sin conexión",
      "keepDataFor": "Conservar datos de",
      "days": "{{count}} día",
      "days_plural": "{{count}} días",
      "capped": "Mostrando {{count}} día. Este espacio de trabajo tiene demasiada actividad para un periodo más largo.",
      "capped_plural": "Mostrando {{count}} días. Este espacio de trabajo tiene demasiada actividad para un periodo más largo.",
      "syncNow": "Sincronizar ahora",
      "status": {
        "title": "Estado",
        "syncing": "Sincronizando…",
        "upToDate": "Actualizado, sincronizado {{age}}",
        "retrying": "Algunos elementos no se sincronizaron. Reintentando.",
        "offline": "Última sincronización {{age}}. Conéctate para sincronizar.",
        "neverOffline": "Aún sin sincronizar. Conéctate para sincronizar.",
        "never": "Aún sin sincronizar"
      },
      "storage": {
        "title": "Almacenamiento",
        "data": "Datos",
        "kb": "{{size}} KB",
        "mb": "{{size}} MB"
      }
    }
  },
  "workspace": {
    "editTitle": "Información del espacio de trabajo",
    "titleSingular": "Espacio de trabajo",
    "filter": {
      "searchPlaceholder": "Buscar nombre",
      "columnButton": "Columnas",
      "tierButton": "Suscripción",
      "columnSelection": "Columnas",
      "tierSelection": "Suscripción",
      "typeSelection": "Tipo",
      "columns": {
        "name": "Nombre",
        "owner": "Administrador",
        "type": "Tipo",
        "subscriptionTierId": "Suscripción",
        "assetsCount": "Activos",
        "routinesCount": "Rutinas",
        "assetAlerts": "Alertas de Activos",
        "groupAlerts": "Alertas de Grupo",
        "peopleCount": "Personas",
        "activitiesCount": "Actividades",
        "groupsCount": "Grupos",
        "createdAt": "Creado en",
        "createdDate": "Fecha de creación",
        "createdTime": "Hora de creación",
        "createdBy": "Creado por",
        "lastScanned": "Último escaneo",
        "lastScannedDate": "Fecha del último escaneo",
        "lastScannedTime": "Hora del último escaneo",
        "updatedAt": "Última actualización",
        "updatedDate": "Fecha de la última actualización",
        "updatedTime": "Hora de la última actualización",
        "lastActivity": "Última actividad",
        "lastActivityDate": "Fecha de la última actividad",
        "lastActivityTime": "Hora de la última actividad"
      }
    },
    "types": {
      "PRODUCER": "Productor",
      "OEM": "OEM"
    },
    "create": {
      "addButton": "Entregar",
      "administratorEmail": "Correo electrónico del administrador",
      "administratorPhone": "Número de teléfono del administrador",
      "administratorFirstName": "Nombre del administrador",
      "administratorLastName": "Apellido del administrador",
      "copyRoutines": "Copiar rutinas",
      "title": "Crear espacio de trabajo",
      "validation": {
        "admin_email_required": "Se requiere el correo electrónico del administrador",
        "admin_first_name_required": "Se requiere el nombre del administrador",
        "admin_last_name_required": "Se requiere el apellido del administrador",
        "name_required": "El nombre del espacio de trabajo es obligatorio.",
        "valid_emil": "El correo electrónico del administrador debe ser una dirección de correo electrónico válida."
      },
      "type": "Tipo",
      "workspaceName": "Nombre del espacio de trabajo",
      "name": "Nombre del espacio de trabajo"
    },
    "createButton": "Crear espacio de trabajo",
    "menu": {
      "editWorkspace": "Editar espacio de trabajo",
      "duplicateWorkspace": "Duplicar espacio de trabajo"
    },
    "duplicate": {
      "title": "Duplicar espacio de trabajo",
      "sourceLabel": "Duplicando desde",
      "contentToCopy": "Contenido a copiar",
      "activities": "Actividades",
      "assets": "Activos",
      "routines": "Rutinas",
      "people": "Personas",
      "alerts": "Alertas",
      "groups": "Grupos",
      "duplicateButton": "Duplicar espacio de trabajo"
    },
    "deleteWorkspace": {
      "deleteWorkspace": "Eliminar espacio de trabajo",
      "alertBody1": "¿Seguro que desea eliminar?",
      "alertBody2": "Nota: ",
      "alertBody3": "Esto no eliminará ningún activo asociado a este grupo ",
      "alertBody4": "espacio de trabajo.",
      "delete": "Eliminar",
      "cancel": "Cancelar"
    },
    "list": {
      "name": "Nombre",
      "owner": "Administrador",
      "type": "Tipo",
      "assetsCount": "Activos",
      "routinesCount": "Rutinas",
      "assetAlerts": "Alertas de Activos",
      "groupAlerts": "Alertas de Grupo",
      "peopleCount": "Personas",
      "activitiesCount": "Actividades",
      "groupsCount": "Grupos",
      "createdAt": "Creado en",
      "createdDate": "Fecha de creación",
      "createdTime": "Hora de creación",
      "createdBy": "Creado por",
      "lastScanned": "Último escaneo",
      "lastScannedDate": "Fecha del último escaneo",
      "lastScannedTime": "Hora del último escaneo",
      "updatedAt": "Última actualización",
      "updatedDate": "Fecha de la última actualización",
      "updatedTime": "Hora de la última actualización",
      "lastActivity": "Última actividad",
      "lastActivityDate": "Fecha de la última actividad",
      "lastActivityTime": "Hora de la última actividad"
    }
  },
  "permissions": {
    "allSet": "¡Todo listo, vamos a comenzar con Gripp!",
    "backButton": "Atrás",
    "camera": {
      "button": "Continuar",
      "denied": {
        "description1": "El acceso a la cámara permite capturar e informar.",
        "title": "Acceso a la cámara, para capturar, mensaje e informar."
      },
      "initial": {
        "description1": "Tomar notas y problemas de informes a menudo requieren que tome una foto de lo que ve.",
        "title": "Acceso a su cámara, para capturar, mensaje e informar."
      }
    },
    "continueButton": "Continuar",
    "enableInSettings": "Puede habilitar este permiso en la configuración del sistema.",
    "gallery": {
      "button": "Continuar",
      "denied": {
        "description1": "El acceso a la galería permite cargar las imágenes que elija.",
        "title": "Acceso a la galería de fotos, para subir imágenes."
      },
      "initial": {
        "description1": "A veces ya tienes imágenes que quieres subir en Gripp.",
        "description2": "Gripp solo tendrá acceso a las imágenes que elija en el punto de cargar.",
        "title": "Acceso a su galería de fotos, para subir fotos."
      }
    },
    "location": {
      "button": "Continuar",
      "denied": {
        "description1": "La ubicación ayuda a realizar un seguimiento de sus activos.",
        "title": "Acceso a la ubicación, para rastrear sus activos."
      },
      "initial": {
        "description1": "Gripp usa la ubicación de su teléfono para actualizar la ubicación de sus activos cuando los escanea.",
        "description2": "Como mínimo, le pedimos que permita la ubicación mientras usa la aplicación.",
        "title": "Acceso a su ubicación, para rastrear sus activos."
      }
    },
    "notification": {
      "button": "Continuar",
      "denied": {
        "description1": "Obtenga alertas de equipo, problemas e informes, sin mensajes de marketing.",
        "title": "Notificaciones, para mantenerse actualizado."
      },
      "initial": {
        "description1": "Se le notificará cuando llegue una nueva alerta, problema o informe.",
        "description2": "Estos son solo para notificaciones de equipo y no están relacionadas con las notificaciones de marketing.",
        "title": "Manténgase actualizado con notificaciones."
      }
    },
    "openSetting": "Abrir configuración",
    "welcome": {
      "description1": "Para usar Gripp, necesitamos habilitar varios permisos.",
      "description2": "Te guiaremos a través de cada uno para explicar por qué lo necesitamos.",
      "description3": "Puedes ajustar todas las configuraciones en cualquier momento a través de los ajustes de tu teléfono.",
      "title": "¡Bienvenido a Gripp!"
    }
  },
  "routine": {
    "list": {
      "name": "Nombre",
      "type": "Tipo de rutina",
      "groups": "Grupos",
      "routines": "Rutinas",
      "oldRoutines": "Rutinas Antiguas",
      "asset": {
        "name": "Nombre",
        "description": "Descripción",
        "groups": "Grupos"
      }
    },
    "filter": {
      "searchPlaceholder": "Buscar nombre de rutina",
      "columnButton": "Columnas",
      "columnSelection": "Columnas",
      "columns": {
        "name": "Nombre",
        "type": "Tipo de Rutina",
        "assetsCount": "Activos",
        "addonsCount": "Complementos",
        "allAssetsCount": "Todos los activos",
        "submissionsCount": "Envíos",
        "groups": "Grupos",
        "groupNames": "Nombres de Grupos",
        "lastSubmitted": "Último Envío",
        "updatedAt": "Última Edición",
        "createdAt": "Fecha de Creación",
        "workspace": "Espacio de trabajo"
      }
    },
    "rowHeader": {
      "routineSelected": "1 rutina seleccionada",
      "routinesSelected": "{{count}} rutinas seleccionadas"
    },
    "permittedRoles": {
      "label": "Roles Permitidos",
      "noRoles": "No hay roles disponibles"
    },
    "print": {
      "button": "Imprimir",
      "previewTitle": "Vista previa de impresión",
      "date": "Fecha",
      "required": "requerido",
      "signature": "Firma",
      "photo": "Foto",
      "quantity": "Cant.",
      "memo": "Nota",
      "startTime": "Inicio",
      "endTime": "Fin",
      "time": "Hora",
      "location": "Ubicación",
      "barcode": "Código de barras",
      "notFound": "No se pudo cargar esta rutina."
    }
  },
  "product": {
    "change": "Cambiar",
    "list": {
      "products": "Productos",
      "name": "Nombre",
      "description": "Descripción",
      "assetsCount": "Activos",
      "filesCount": "Archivos",
      "addonsCount": "Complementos",
      "routines": "Rutinas",
      "alerts": "Alertas de Activos",
      "productAlerts": "Alertas de Productos",
      "createdAt": "Fecha de creación",
      "updatedAt": "Última actualización"
    },
    "filter": {
      "searchPlaceholder": "Buscar nombre del producto",
      "columnButton": "Columnas",
      "columns": {
        "name": "Nombre",
        "description": "Descripción",
        "assetsCount": "Activos",
        "filesCount": "Archivos",
        "addonsCount": "Complementos",
        "routines": "Rutinas",
        "alerts": "Alertas de Activos",
        "productAlerts": "Alertas de Productos",
        "createdAt": "Fecha de creación",
        "updatedAt": "Última actualización"
      },
      "columnSelection": "Columnas"
    },
    "create": {
      "label": "Crear un Nuevo Producto",
      "validation": {
        "name_required": "El nombre del producto es obligatorio"
      },
      "cancel": "Cancelar",
      "create": "Crear",
      "placeholder": "p. ej., Producto 1"
    },
    "delete": {
      "button": "Eliminar producto",
      "cancel": "Cancelar",
      "confirm": "Sí",
      "title": "¿Estás seguro de que deseas eliminar el producto {{productName}}?"
    },
    "detail": {
      "addon_options": "Opciones adicionales",
      "no_addon_options": "No hay opciones adicionales para este producto.",
      "add_more": "Agregar más",
      "description": "Descripción",
      "details": "Detalles",
      "files": {
        "placeholder": "¿Algún archivo adicional para subir? (placas de datos, calcomanías del fabricante, etc.)",
        "addFilesLinks": "Agregar archivos / enlaces"
      },
      "save": "Guardar",
      "cancel": "Cancelar",
      "profile": "Perfil del producto",
      "assets": "Activos",
      "routines": "Rutinas",
      "noAvailableRoutines": "No hay rutinas disponibles para agregar",
      "edit": "Editar",
      "delete": "Eliminar",
      "confirmDelete": "¿Estás seguro de que deseas eliminar el producto {{fileName}}?"
    },
    "specifications": {
      "title": "Todas las Especificaciones",
      "upload": "Subir Datos",
      "download": "Descargar",
      "add_more": "Agregar más",
      "label_placeholder": "Nombre de especificación",
      "value_placeholder": "Valor",
      "delete_confirm": "¿Estás seguro de que quieres eliminar esta especificación?",
      "upload_coming_soon": "La funcionalidad de subida CSV llegará pronto",
      "download_coming_soon": "La funcionalidad de descarga CSV llegará pronto",
      "upload_success": "Especificaciones subidas exitosamente",
      "upload_error": "Error al subir especificaciones. Inténtalo de nuevo.",
      "download_error": "Error al descargar especificaciones. Inténtalo de nuevo.",
      "download_title": "Descargar Especificaciones",
      "no_data_to_download": "No hay especificaciones para descargar",
      "sharing_not_available": "El intercambio de archivos no está disponible en este dispositivo"
    },
    "assignments": {
      "assets": "Activos",
      "routines": "Rutinas",
      "files": "Archivos",
      "addons": "Complementos",
      "searchPlaceholder": "Buscar nombre",
      "assetSearchPlaceholder": "Buscar nombre de activo",
      "routineSearchPlaceholder": "Buscar nombre de rutina",
      "fileSearchPlaceholder": "Buscar nombre de archivo",
      "addonSearchPlaceholder": "Buscar nombre de complemento"
    }
  },
  "file": {
    "list": {
      "files": "Archivos",
      "name": "Nombre",
      "products": "Productos",
      "assets": "Recursos",
      "addons": "Complementos",
      "categories": "Categorías",
      "lastUpdated": "Última actualización",
      "createdAt": "Fecha de creación"
    },
    "filter": {
      "searchPlaceholder": "Buscar nombre de archivo",
      "columnButton": "Columnas",
      "categories": "Categorías",
      "searchCategories": "Buscar categorías",
      "deleteCategory": "Eliminar Categoría",
      "deleteCategoryMessage": "¿Está seguro de que desea eliminar \"{{categoryName}}\"? Esto eliminará la categoría de {{fileCount}} archivos.",
      "columns": {
        "name": "Nombre",
        "productsCount": "Productos",
        "assetsCount": "Recursos",
        "addonsCount": "Complementos",
        "categories": "Categorías",
        "updatedAt": "Última actualización",
        "createdAt": "Fecha de creación"
      },
      "columnSelection": "Columnas"
    },
    "assignments": {
      "productsSearchPlaceholder": "Buscar nombre del producto",
      "addonsSearchPlaceholder": "Buscar nombre del complemento"
    },
    "create": {
      "label": "Agregar Archivo",
      "linkLabel": "Agregar Enlace",
      "title": "Título",
      "linkUrl": "URL del Enlace",
      "category": "Categoría",
      "file": "Archivo (un archivo solamente)",
      "link": "Enlace (un enlace solamente)",
      "add": "Agregar",
      "addLink": "Agregar Enlace",
      "titlePlaceholder": "Ingrese el título del archivo",
      "linkUrlPlaceholder": "Ingrese URL (ej., https://ejemplo.com)",
      "categoryPlaceholder": "Seleccionar categorías",
      "categorySearchPlaceholder": "Buscar categorías",
      "createCategory": "Crear Categoría",
      "enterCategoryNamePlaceholder": "Ingresar nombre de categoría",
      "creatingCategory": "Creando...",
      "selectCategory": "Seleccionar categorías",
      "searchCategory": "Buscar categorías",
      "emptyStateMessage": "Crear una categoría escribiendo directamente en la barra de búsqueda.",
      "clickToUpload": "Haga clic para subir archivo",
      "linkPlaceholder": "Ingrese URL (ej., https://ejemplo.com)",
      "validation": {
        "title_required": "El título del archivo es requerido",
        "category_required": "Al menos una categoría es requerida",
        "link_required": "La URL del enlace es requerida",
        "link_invalid": "Por favor ingrese una URL válida"
      },
      "uploadError": "No se pudo subir el archivo. Por favor, inténtalo de nuevo.",
      "linkError": "No se pudo crear el enlace. Por favor, inténtalo de nuevo.",
      "placeholder": "Nombre del archivo",
      "fileNumber": "Archivo {{index}} de {{count}}",
      "partialUploadError": "Algunos archivos no se pudieron subir. Guarda de nuevo para reintentarlo.",
      "removeFile": "Quitar archivo"
    },
    "dropdown": {
      "createFile": "Crear Archivo",
      "file": "Archivo",
      "link": "Enlace"
    },
    "tabs": {
      "products": "Productos",
      "addons": "Complementos"
    },
    "deleteFile": {
      "deleteFile": "Eliminar Archivo",
      "alertBody1": "¿Está seguro de que desea eliminar",
      "delete": "Eliminar",
      "cancel": "Cancelar"
    },
    "assets": {
      "title": "Recursos",
      "name": "Nombre",
      "description": "Descripción",
      "lastScanned": "Último Escaneado",
      "lastAddress": "Última Dirección",
      "lastUpdated": "Última Actualización",
      "noAssets": "No se encontraron recursos"
    }
  },
  "addOn": {
    "list": {
      "addOns": "Complementos",
      "name": "Nombre",
      "product": "Productos",
      "asset": "Activos",
      "media": "Archivos",
      "routines": "Rutinas",
      "createdAt": "Creado el",
      "updatedAt": "Última actualización",
      "addon": "Complemento"
    },
    "filter": {
      "searchPlaceholder": "Buscar nombre del complemento",
      "columnButton": "Columnas",
      "columns": {
        "name": "Nombre",
        "product": "Productos",
        "asset": "Activos",
        "media": "Archivos",
        "routines": "Rutinas",
        "createdAt": "Creado el",
        "updatedAt": "Última actualización"
      },
      "columnSelection": "Columnas"
    },
    "create": {
      "label": "Crear Complemento",
      "validation": {
        "name_required": "El nombre del complemento es obligatorio"
      },
      "cancel": "Cancelar",
      "create": "Crear",
      "placeholder": "ej. Complemento 1"
    },
    "assignment": {
      "productSearchPlaceholder": "Buscar nombre del producto",
      "mediaSearchPlaceholder": "Buscar nombre del archivo",
      "routineSearchPlaceholder": "Buscar nombre de rutina",
      "success": "Productos asignados al complemento exitosamente",
      "error": "Debe proporcionar IDs de productos"
    },
    "files": {
      "title": "Archivos",
      "name": "Nombre",
      "type": "Tipo",
      "extension": "Extensión",
      "textEmpty": "No se encontraron archivos",
      "addFilesLinks": "Agregar archivos / enlaces",
      "save": "Guardar",
      "delete": "Eliminar",
      "list": {
        "name": "Nombre",
        "categories": "Categorías"
      }
    },
    "textEmpty": "Toca '+ Crear Complemento' para agregar tu primer complemento.",
    "edit": {
      "label": "Editar Complemento",
      "save": "Guardar"
    },
    "deleteAddon": "Eliminar Complemento"
  },
  "labels": {
    "confirmTextLine1": "Está seguro de que desea eliminar la etiqueta \"{{labelName}}\"?",
    "confirmTextLine2": "Esto eliminará la etiqueta de {{activityCount}} actividades existentes.",
    "cancel": "Cancelar",
    "delete": "Borrar",
    "editLabels": "Editar Etiquetas",
    "labels": "Etiquetas",
    "yes": "Sí"
  },
  "categories": {
    "confirmTextLine1": "Está seguro de que desea eliminar la categoría \"{{categoryName}}\"?",
    "confirmTextLine2": "Esto eliminará la categoría de {{fileCount}} archivos existentes.",
    "cancel": "Cancelar",
    "delete": "Borrar",
    "editCategories": "Editar Categorías",
    "categories": "Categorías",
    "yes": "Sí"
  },
  "integrations": {
    "description": "Conecta tu espacio de trabajo a los servicios compatibles.",
    "cnh": "CNH FieldOps",
    "connected": "Conectado",
    "notConnected": "Sin conexión",
    "connectedBy": "Conectado por",
    "connectedAt": "Fecha de conexión",
    "lastValidatedAt": "Última validación",
    "notAvailable": "No disponible",
    "connect": "Conectar FieldOps",
    "disconnect": "Desconectar FieldOps",
    "disconnectConfirm": "¿Desconectar FieldOps de este espacio de trabajo? Puedes volver a conectarlo más adelante.",
    "loading": "Cargando integraciones…",
    "unavailable": "Las integraciones no están disponibles para este espacio de trabajo.",
    "loadError": "No se pudieron cargar las integraciones. Comprueba la conexión e inténtalo de nuevo.",
    "retry": "Reintentar",
    "popupBlocked": "Tu navegador bloqueó la pestaña de autorización. Permite las ventanas emergentes de Gripp y vuelve a pulsar Conectar FieldOps.",
    "tabClosed": "Se cerró la pestaña de autorización. Pulsa Conectar FieldOps para iniciar un nuevo intento.",
    "consentOpened": "Completa la autorización en la nueva pestaña y vuelve aquí para ver el estado de la conexión.",
    "disconnectedNotice": "FieldOps está desconectado.",
    "busyError": "Hay otro cambio de conexión en curso. Espera a que termine e inténtalo de nuevo.",
    "permissionError": "Ya no tienes permiso para modificar esta conexión.",
    "actionError": "No se pudo modificar la conexión. Comprueba la red e inténtalo de nuevo.",
    "providers": {
      "geotab": "GeoTab",
      "johnDeere": "John Deere Operations",
      "caseIh": "Case IH"
    },
    "attribution": {
      "autoSynced": "Sincronizado automáticamente"
    },
    "digest": {
      "title": "{{count}} activo sincronizado",
      "title_plural": "{{count}} activos sincronizados",
      "titleSegment": "{{provider}} sincronizó {{count}} activo",
      "titleSegment_plural": "{{provider}} sincronizó {{count}} activos",
      "failedDescription": "Error de sincronización — los datos pueden estar desactualizados",
      "readingsCount": "{{count}} lectura",
      "readingsCount_plural": "{{count}} lecturas",
      "faultsCount": "{{count}} falla",
      "faultsCount_plural": "{{count}} fallas",
      "detailTitle": "Resumen de sincronización",
      "detailEmpty": "No hay detalle por activo disponible"
    },
    "readings": {
      "fallbackRoutineName": "Lectura"
    }
  },
  "share": {
    "expiresOn": "Este enlace caduca el {{date}}"
  },
  "chat": {
    "sideChatPanel": {
      "back": "Volver a la conversación",
      "title": "Chat paralelo",
      "placeholder": "Chatea con contexto…"
    },
    "route": {
      "denied": "No tienes acceso a este chat.",
      "unavailable": "Este chat no está disponible."
    },
    "filters": {
      "toggleLabel": "Filtrar conversación",
      "all": "Todo",
      "messages": "Mensajes",
      "activities": "Actividades",
      "urgent": "Urgente",
      "pending": "Pendiente",
      "solved": "Resuelto"
    },
    "panel": {
      "title": "Chat"
    },
    "composer": {
      "addDocument": "Añadir documento",
      "addImage": "Añadir imagen",
      "asMessage": "Mensaje",
      "locationAttached": "Ubicación adjunta",
      "placeholder": "Enviar un mensaje a {{asset}}…",
      "placeholderFallback": "Enviar un mensaje a este activo…",
      "postAsMessageInstead": "Publicar como mensaje en su lugar",
      "postFailed": "No se pudo publicar tu mensaje. Inténtalo de nuevo.",
      "postingAs": "Publicando como {{type}}",
      "removeLocation": "Quitar ubicación",
      "sendAs": "Enviar como",
      "sendAsType": "Enviar como {{type}}",
      "send": "Enviar",
      "shareLocation": "Compartir ubicación"
    },
    "feed": {
      "filteredEmptyTitle": "Nada coincide con este filtro",
      "emptyTitle": "Todavía no hay nada aquí",
      "errorTitle": "No se pudo cargar el chat",
      "retry": "Reintentar"
    },
    "row": {
      "you": "Tú",
      "thread": "{{count}} respuesta · Hilo",
      "thread_plural": "{{count}} respuestas · Hilo",
      "menu": {
        "call": "Llamar",
        "more": "Más opciones para {{name}}",
        "share": "Compartir",
        "sideChat": "Chat paralelo",
        "thread": "Hilo"
      },
      "sideChat": "{{count}} respuesta · Chat paralelo",
      "sideChat_plural": "{{count}} respuestas · Chat paralelo",
      "sideChatFailed": "No se pudo iniciar el chat paralelo. Inténtalo de nuevo.",
      "sideChatCount": "{{count}} chat paralelo",
      "sideChatCount_plural": "{{count}} chats paralelos",
      "sideChatNamed": "{{count}} respuesta · {{name}}",
      "sideChatNamed_plural": "{{count}} respuestas · {{name}}"
    },
    "icon": {
      "label": "Abrir chat",
      "labelWithUnread": "Abrir chat ({{count}} nuevo)",
      "labelWithUnread_plural": "Abrir chat ({{count}} nuevos)"
    },
    "thread": {
      "notePlaceholder": "Responder en el hilo…",
      "activityPlaceholder": "Compartir con Gripp...",
      "copied": "¡Copiado!",
      "copyError": "No se pudo copiar al portapapeles. Verifica los permisos de tu navegador e inténtalo de nuevo.",
      "copy": "Copiar"
    },
    "band": {
      "toggleLabel": "Más opciones",
      "menu": {
        "share": "Compartir"
      }
    },
    "share": {
      "description": "Cualquiera con este enlace puede iniciar sesión y unirse: solo podrá ver este activo y nada más en este espacio de trabajo.",
      "error": "No se pudo crear el enlace para compartir. Inténtalo de nuevo.",
      "copyLink": "Copiar enlace",
      "copied": "Enlace copiado",
      "copyError": "No se pudo copiar el enlace"
    },
    "join": {
      "error": "No se pudo unir. Inténtalo de nuevo.",
      "removedError": "Se ha revocado tu acceso a este espacio de trabajo y no puedes unirte de nuevo mediante este enlace.",
      "unavailable": "Este activo compartido ya no está disponible.",
      "resolveError": "Este enlace no es válido o ya no está activo."
    },
    "participants": {
      "title": "Participantes",
      "titleWithCount": "Participantes · {{count}}",
      "empty": "Todavía no hay participantes",
      "errorTitle": "No se pudieron cargar los participantes"
    },
    "native": {
      "participantsToggle": "Mostrar participantes"
    }
  }
}
